<template lang="html">
    <div class="app application-scope container">
        <main class="stickywrapper">
            <div class="loading margin-top-20" v-if="siteLoadStatus == 1">
                <p>{{ $t('default.loading') }}</p>
            </div>

            <div class="error margin-top-20" v-if="siteLoadStatus == 3">
                <p>{{ $t('error.something_went_wrong') }}</p>
            </div>

            <router-view v-if="siteLoadStatus == 2 || siteLoadStatus == 4">

            </router-view>
        </main>
        <footer class="footer" v-if="siteLoadStatus == 2 && site.show_disclaimers == 1">
            <div class="col">
                <ul class="list-unstyled">
                    <li><a :href="site.general_terms">{{ $t('default.general_terms') }}</a></li>
                    <li><a :href="site.privacy_statement">{{ $t('default.privacy_statement') }}</a></li>
                    <li><a :href="site.imprint">{{ $t('default.imprint') }}</a></li>
                </ul>
            </div>
        </footer>
    </div>
</template>

<script>
import store from '../store/index.js'

export default {
    store,
    name: "App",
    beforeCreate() {
        this.$store.dispatch('loadSiteData');
    },
    computed: {
        siteLoadStatus() {
             return this.$store.getters.getSiteLoadStatus;
        },
        site() {
            return this.$store.getters.getSiteData;
        }
    },
}
</script>
